import { useState } from 'react';

/**
 * Document actions for a saved proposal / agreement / invoice.
 *
 * PAUSED: send-to-Messages. The share-sheet and sms: routes are deliberately
 * switched off for now (see SHARE_TO_MESSAGES below) — re-enabling is a
 * one-line change, and ShareSheetRoute keeps the awkward parts documented so
 * they don't have to be rediscovered.
 *
 * Two things to know if it comes back:
 *
 *  - Apple publishes no iMessage API. Sending a quote as an iMessage is only
 *    possible from the owner's own device via the native share sheet; a server
 *    cannot do it. The sheet picks the recipient, so no phone number is needed
 *    — the number only ever prefilled the sms: fallback, which is optional.
 *
 *  - navigator.share() requires transient user activation, and an `await`
 *    before calling it consumes that activation, so Safari throws
 *    NotAllowedError. The PDF has to be fetched *before* the click, not inside
 *    the handler. Both Web Share and file sharing are also secure-context
 *    only, so neither exists over plain http on an IP address.
 */
const SHARE_TO_MESSAGES = false;

export default function ShareButton({ pdfUrl, publicUrl, filename, onOpen }) {
  const [status, setStatus] = useState('');

  const say = (msg) => {
    setStatus(msg);
    setTimeout(() => setStatus(''), 2500);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      say('Link copied');
    } catch {
      say(publicUrl);
    }
  };

  return (
    <div className="col" style={{ gap: 'var(--s-2)' }}>
      <div className="btn-row">
        {/* With onOpen the PDF opens in an in-app viewer that has a Close button;
            otherwise it falls back to a plain new tab. */}
        {onOpen ? (
          <button type="button" className="btn pri" onClick={onOpen}>📄 Open PDF</button>
        ) : (
          <a className="btn pri" href={pdfUrl} target="_blank" rel="noopener noreferrer">📄 Open PDF</a>
        )}
        <a className="btn" href={`${pdfUrl}${pdfUrl.includes('?') ? '&' : '?'}download=1`} download={filename}>
          ⬇ Download
        </a>
        <button className="btn" onClick={copyLink}>🔗 Copy link</button>
      </div>
      {status ? <p className="sb" role="status">{status}</p> : null}
    </div>
  );
}
